import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IAreaTypeResponse } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const GET_AREA_TYPES_UUID = createUUID();
const GET_RECENT_AREA_TYPES_UUID = createUUID();

export const useAreaTypes = () => {
  const [areaTypes, setAreaTypes] = useState<IAreaTypeResponse[]>([]);
  const [recentAreaTypes, setRecentAreaTypes] = useState<IAreaTypeResponse[]>(
    []
  );

  const stateManager = useComponentState();

  const getAreaTypes = async ({ top, skip, search = "" }: IApiRequest = {}) => {
    stateManager.abort(GET_AREA_TYPES_UUID);

    const response = await stateManager.run(async () => {
      return homeService.areaTypes.getAll({
        top,
        skip,
        sort: "name asc",
        filters: { name: { contains: search } },
      });
    }, GET_AREA_TYPES_UUID);
    if (response.status === HTTP_STATUSES.OK) {
      setAreaTypes(response.data);
    }
    return response;
  };

  const getRecentAreaTypes = async ({
    sort,
    filters,
    top,
    search = "",
  }: IApiRequest) => {
    stateManager.abort(GET_RECENT_AREA_TYPES_UUID);

    const response = await stateManager.run(async () => {
      return homeService.areaTypes.getAll({
        sort,
        top,
        filters: {
          ...filters,
          name: { contains: search },
        },
      });
    }, GET_RECENT_AREA_TYPES_UUID);
    if (response.status === HTTP_STATUSES.OK) {
      setRecentAreaTypes(response.data);
    }
    return response;
  };

  return {
    isLoading: stateManager.isBusy(),
    areaTypes,
    recentAreaTypes,
    setAreaTypes,
    setRecentAreaTypes,
    getAreaTypes,
    getRecentAreaTypes,
  };
};
